// AuthGuard.jsx
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const AuthGuard = ({ children }) => {
  const accessToken = useSelector((state) => state.auth.accessToken);
  const location = useLocation();

  // Handle root path "/"
  if (location.pathname === "/" ||  location.pathname === "/auth/login" ) {
    if (accessToken) {
      return <Navigate to="/admin/dashboard" replace />;
    } else {
        if( location.pathname !== "/auth/login"){
            return <Navigate to="/auth/login" replace />;
        }
    }
  }

  return children;
};

export default AuthGuard;
